export const getUdReassignment = (originalData) =>
  originalData?.udReassignment;

export const isUdReassignmentEnabled = (meta) => meta?.enabled === true;

const normalizeId = (value) => {
  if (value == null || value === '') return '';
  return String(value).trim().toLowerCase();
};

const getEntryStatus = (entry) => {
  if (!entry?.status) return '';
  if (typeof entry.status === 'object') return entry.status.label || entry.status.value || '';
  return entry.status;
};

const getEntryCandidateIds = (entry) =>
  [entry?.eventId, entry?.event_id, entry?.id, entry?.key]
    .map(normalizeId)
    .filter(Boolean);

export const isEligibleUdDrivingEntry = (entry, meta) => {
  if (!entry || !isUdReassignmentEnabled(meta)) return false;
  if (Array.isArray(meta?.eligibleEventIds)) {
    const candidates = getEntryCandidateIds(entry);
    return meta.eligibleEventIds.some((id) => candidates.includes(normalizeId(id)));
  }
  return getEntryStatus(entry) === 'DRIVING';
};

export const hasActiveUdReassignmentRequests = (meta) => meta?.activeRequests?.length > 0;

export const isWholeLogEditBlockedByUd = (meta) => {
  if (!meta) return false;
  if (meta.canEditWholeLog === false) return true;
  if (meta.activeRequests?.length > 0) return true;
  return false;
};

const normalizeDriverId = (driverId) => {
  if (driverId == null || driverId === '') return null;
  if (typeof driverId === 'object') return String(driverId.value ?? driverId);
  return String(driverId);
};

export const getCurrentDriverLabel = (entry, companyDrivers = {}) => {
  const driverId = normalizeDriverId(entry?.driverId);
  if (!driverId) return '-';
  return companyDrivers[driverId] || entry?.driverFullName || driverId;
};
